<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-6 small-columns-12">
            <mat-label>{{ 'forms.payroll-off-cycle.payDate' | translate }}</mat-label>
            <input
                name="payDate"
                #payDate="ngModel"
                [min]="minDate"
                required
                [(ngModel)]="payroll.payDate"
                [matDatepicker]="payDatePicker"
                matInput
            />
            <mat-datepicker-toggle matSuffix [for]="payDatePicker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #payDatePicker></mat-datepicker>
            <mat-error *ngIf="payDate.invalid">{{ payDate.errors | formErrors }}</mat-error>
        </mat-form-field>
        <div class="columns-6 small-columns-12 info-text">
            {{ 'forms.payroll-off-cycle.humiNeedsBusinessDaysToProcessPayrollYouCanCreateOffcyclePayroll' | translate }}
        </div>
        <div class="columns-6 small-columns-12">
            <mat-slide-toggle
                name="addAllEmployees"
                [(ngModel)]="payroll.addAllEmployees"
                #addAllEmployees="ngModel"
                color="primary"
                class="align-toggle"
                >{{ 'forms.payroll-off-cycle.addAllEmployees' | translate }}
            </mat-slide-toggle>
        </div>
        <div class="columns-6 small-columns-12 info-text">
            {{ 'forms.payroll-off-cycle.youllStillHaveAchanceToAddOrRemoveEmployeesIndividuallyWhileEdit' | translate }}
        </div>
    </div>
</form>
